import characterAnimationsFactory from '@/helpers/characterAnimationsFactory';
import voicetechCharsAnimationsFactory from '@/helpers/voicetechCharsAnimationsFactory';
import itemAnimationsFactory from '@/helpers/itemAnimationsFactory';
import { createHolidayAnimations } from '@/helpers/holidayCharacterAnimationsFactory';
import { loadAudio } from '../helpers/audioFactory';

export default class SplashScreen extends Phaser.Scene {
  /**
   *  Takes care of loading the main game assets, including textures, tile
   *  maps, sound effects and other binary files, while displaying a busy
   *  splash screen.
   *
   *  @extends Phaser.Scene
   */
  constructor() {
    super({
      key: 'SplashScreen',

      //  Splash screen and progress bar textures.
      pack: {
        files: [{
          key: 'splash-screen',
          type: 'image'
        }, {
          key: 'progress-bar',
          type: 'image'
        }]
      }
    });

  }

  /**
   *  Show the splash screen and prepare to load game assets.
   *
   *  @protected
   */
  preload() {
    //  Display cover and progress bar textures.
    this.showCover();
    this.showProgressBar();

    //  HINT: Declare all game assets to be loaded here.
    this.load.image('logo');
    this.load.multiatlas('characters', 'characters.json'); // talk2megoosmean
    this.load.multiatlas('voicetechchars','voicetechchars.json'); // VoicetechGuy Goldzulu
    this.load.multiatlas('holiday-characters', 'holiday-characters.json'); // talk2megoosmean
    this.load.multiatlas('items', 'items.json');
    this.load.image('spiked_ball', 'spikedball.png');

    this.load.atlas('explosion', 'explosion.png', 'explosion.json');

    loadAudio(this);
  }

  /**
   *  Set up animations, plugins etc. that depend on the game assets we just
   *  loaded.
   *
   *  @protected
   */
  create() {
    characterAnimationsFactory(this);
    voicetechCharsAnimationsFactory(this);
    itemAnimationsFactory(this);
    createHolidayAnimations(this);
    //  We have nothing left to do here. Start the next scene.
    this.scene.start('Game');
  }

  //  ------------------------------------------------------------------------

  /**
   *  Show the splash screen cover.
   *
   *  @private
   */
  showCover() {
    this.add.image(0, 0, 'splash-screen').setOrigin(0);
  }

  /**
   *  Show the progress bar and set up its animation effect.
   *
   *  @private
   */
  showProgressBar() {
    //  Get the progress bar filler texture dimensions.
    const {width: w, height: h} = this.textures.get('progress-bar').get();

    //  Place the filler over the progress bar of the splash screen.
    const img = this.add.sprite(82, 282, 'progress-bar').setOrigin(0);

    //  Crop the filler along its width, proportional to the amount of files
    //  loaded.
    this.load.on('progress', v => img.setCrop(0, 0, Math.ceil(v * w), h));
  }
}
